import { Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';

type Props = {
    title: string;
    children: React.ReactNode;
    isShow?: boolean;
    placement?:
        | 'top'
        | 'left'
        | 'right'
        | 'bottom'
        | 'topLeft'
        | 'topRight'
        | 'bottomLeft'
        | 'bottomRight'
        | 'leftTop'
        | 'leftBottom'
        | 'rightTop'
        | 'rightBottom';
};
const InputToolTip: React.FC<Props> = ({ title, placement, children, isShow }) => {
    const [isVertical, setIsVertical] = useState(false);
    const [restart, setRestart] = useState(true);

    useEffect(() => {
        if (window.innerWidth < 700) {
            setIsVertical(true);
        }
        if (restart) {
            setRestart(false);
        }

        function handleResize() {
            setIsVertical(window.innerWidth < 700 ? true : false);
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [restart]);

    return (
        <Tooltip
            title={title}
            placement={placement || isVertical ? 'bottom' : 'left'}
            zIndex={isShow ? 10 : isVertical ? -1 : 10}
            defaultVisible={false}
        >
            {children}
        </Tooltip>
    );
};

export default InputToolTip;
